import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
export default {
  name: 'NiotaClassicApplicationsForm',
  mixins: [formMixin],
  props: {
    editedItem: {
      type: Object,
      required: false,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var _this = this;

    return {
      plainAccounts: [],
      diagramPeriods: [2, 3, 4, 5, 6, 7, 14, 31].map(function (days) {
        return {
          text: "".concat(_this.$i18n_t('NiotaClassic.Applications.form.from'), " ").concat(days, " ").concat(_this.$i18n_t('NiotaClassic.Applications.form.days')),
          value: days
        };
      }),
      urlRule: [function (v) {
        return /http(s?):\/\/([a-z0-9]+)\.([a-z]+)/.test(v) || 'Enter a valid URL';
      }],
      addressObject: {
        address: '',
        coordinates: [null, null]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    coordinateLookup: function coordinateLookup() {
      return get(this.formItem, 'properties.coordinateMode') !== 'manual';
    }
  }),
  created: function created() {
    this.formItem = cloneDeep(this.editedItem) || {};
    this.setAddressObject();

    if (!get(this.formItem, 'properties.detailsViewCards')) {
      set(this.formItem, 'properties.detailsViewCards', {});
    }

    this.getPlainAccounts();
  },
  methods: {
    createOrUpdateApplication: function createOrUpdateApplication() {
      if (this.formItem.id) {
        this.updateRequest();
      } else {
        this.createRequest();
      }
    },
    tagsChanged: function tagsChanged(tags) {
      this.formItem.tags = tags;
    },
    updateRequest: function updateRequest() {
      var _this2 = this;

      return NiotaClassicApiService.applicationsUpdate(this.formItem.id, this.formItem).then(function (res) {
        if (!res.data.err) {
          _this2.$snack(_this2.$i18n_t('NiotaClassic.Applications.form.successfulUpdate'), 'success');

          _this2.$emit('update', _this2.formItem);

          _this2.$emit('close');

          _this2.$emit('refreshList');
        } else {
          _this2.$snack(res.data.err, 'error');
        }
      }).catch(function (error) {
        _this2.$snack(get(error, 'response.data.err'), 'error');

        console.error(error);
      });
    },
    createRequest: function createRequest() {
      var _this3 = this;

      NiotaClassicApiService.applicationsCreate(this.formItem).then(function () {
        _this3.$emit('created');

        _this3.$emit('close');

        _this3.$snack(_this3.$i18n_t('NiotaClassic.Applications.snacks.createSuccess'), 'success');
      }).catch(function () {
        _this3.$snack(_this3.$i18n_t('NiotaClassic.Applications.snacks.createFailed'), 'error');
      });
    },
    getPlainAccounts: function getPlainAccounts() {
      var _this4 = this;

      NiotaClassicApiService.accountsFetchPlain().then(function (res) {
        _this4.plainAccounts = res.data.accounts;

        if (_this4.formItem.accountId) {
          _this4.formItem.account = _this4.plainAccounts.find(function (account) {
            return account.id === _this4.formItem.accountId;
          });
        }
      }).catch(function () {
        _this4.$snack(_this4.$i18n_t('NiotaClassic.Applications.snacks.fetchAccountFailed'), 'error');
      });
    },
    getFile: function getFile(file) {
      this.formData = new FormData(); // Muss neu erzeugt werden gegen Duplikate

      this.file = file;
      this.formData.append('file', this.file);
    },
    filterAccounts: function filterAccounts(item, queryText) {
      return item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    uploadImage: function uploadImage(image) {
      var _this5 = this;

      NiotaClassicApiService.uploadImage(image, 'originator').then(function (data) {
        _this5.formItem.image = data.file;
        _this5.formItem = cloneDeep(_this5.formItem);
      }).catch(function (error) {
        // TODO: create toast with error message
        console.error('Error during image upload', error);
      });
    },
    accountUpdated: function accountUpdated() {
      if (this.formItem.account) {
        this.formItem.accountId = this.formItem.account.id;
      }
    },
    setAddressObject: function setAddressObject() {
      this.addressObject = {
        address: {
          formatted_address: this.formItem.applicationAddress
        },
        coordinates: [this.formItem.lon || null, this.formItem.lat || null]
      };
    },
    addressSelected: function addressSelected(addressData) {
      this.formItem.applicationAddress = addressData.address;

      var _addressData$coordina = _slicedToArray(addressData.coordinates, 2);

      this.formItem.lon = _addressData$coordina[0];
      this.formItem.lat = _addressData$coordina[1];
      this.formItem.properties = _objectSpread(_objectSpread({}, this.formItem.properties || {}), {}, {
        coordinateMode: addressData.pickedManualCoordinates ? 'manual' : 'auto'
      });
      this.setAddressObject();
    }
  }
};